/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 27.11.13, 09:32
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

export class AgeGateData {
    private _isAgeGateActive: boolean;
    private _validationSucceeded: boolean;
    private _autoLoginTryFailed: boolean;

    public get isAgeGateActive(): boolean {
        return this._isAgeGateActive;
    }

    public set isAgeGateActive(value: boolean) {
        this._isAgeGateActive = value;
    }

    public get validationSucceeded(): boolean {
        return this._validationSucceeded;
    }

    public set validationSucceeded(value: boolean) {
        this._validationSucceeded = value;
    }

    public get autoLoginTryFailed(): boolean {
        return this._autoLoginTryFailed;
    }

    public set autoLoginTryFailed(value: boolean) {
        this._autoLoginTryFailed = value;
    }
}
